import * as Sentry from "@sentry/nextjs";
import { useEffect, useState } from "react";

import { useContract } from "@/features/nft/hooks/useContract";
import { getPublicConfig } from "@/helpers/getPublicConfig";

export const useTokenBalance = ({
  skip,
  walletAccount,
}: {
  skip?: boolean;
  walletAccount: string;
}) => {
  const {
    service: { openSea },
  } = getPublicConfig();

  const { eth721Contract } = useContract();
  const [balance, setBalance] = useState<number>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);

  useEffect(() => {
    if (!eth721Contract || !walletAccount || skip) return;

    const getBalance = async () => {
      try {
        setError(undefined);
        setLoading(true);
        const tokenBalance = await eth721Contract.methods
          .balanceOf(walletAccount)
          .call();
        setBalance(Number(tokenBalance));
      } catch (error) {
        setError(error);
        Sentry.captureException(error, {
          tags: { eth721Contract: "balanceOf" },
          extra: { walletAccount },
        });
      } finally {
        setLoading(false);
      }
    };

    getBalance();
  }, [eth721Contract, walletAccount, skip, openSea.contractAddress]);

  return { balance, error, loading };
};
